import { getValidHttpUrl } from "@/lib/url";

interface WhatsAppPreviewProps {
  metaTags: {
    og_title?: string;
    og_description?: string;
    og_image?: string;
    og_url?: string;
  };
}

export default function WhatsAppPreview({ metaTags }: WhatsAppPreviewProps) {
  const { og_title, og_description, og_image, og_url } = metaTags;
  const imageUrl = getValidHttpUrl(og_image);

  let hostname = "";
  try {
    if (og_url) {
      hostname = new URL(og_url).hostname.replace("www.", "");
    }
  } catch {
    // Invalid URL, leave hostname empty
  }

  return (
    <div className="w-full max-w-lg rounded-lg bg-[#efeae2] p-4 shadow-md dark:bg-[#0b141a]">
      <div className="ml-auto max-w-sm rounded-lg bg-[#d9fdd3] p-1.5 shadow-sm dark:bg-[#005c4b]">
        <div className="overflow-hidden rounded-md bg-[#d1f4cc] dark:bg-[#025144]">
          {imageUrl ? (
            <img src={imageUrl} alt={og_title ?? ""} className="aspect-[1.91/1] w-full object-cover" />
          ) : (
            <div className="flex h-32 w-full items-center justify-center bg-black/5 dark:bg-white/5">
              <p className="text-sm text-gray-500 dark:text-gray-300">No image available</p>
            </div>
          )}
          <div className="px-2.5 py-2">
            <p className="line-clamp-2 text-sm font-medium text-gray-900 dark:text-gray-100">
              {og_title || "No title found"}
            </p>
            {og_description && (
              <p className="mt-0.5 line-clamp-2 text-xs text-gray-600 dark:text-gray-300">{og_description}</p>
            )}
            {hostname && <p className="mt-0.5 text-xs text-gray-500 dark:text-gray-400">{hostname}</p>}
          </div>
        </div>
        {og_url && <p className="truncate px-1.5 py-1 text-sm text-[#027eb5] dark:text-[#53bdeb]">{og_url}</p>}
      </div>
    </div>
  );
}
